import React, { useState } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import useForm from '@/hooks/useForm';
import { States } from '@/helpers/common/states';
import { AxiosError } from 'axios';
import api from '@/services/api';
import { ChargeBack } from '@/model/ChargeBack';
import { toast } from 'react-toastify';
import validators from '@/helpers/validators';
import { ChargebackContainer } from './ui';
import { FormInputName } from '../types';

export const ChargebackScreen: React.FC = (): JSX.Element => {
  const [state, setState] = useState<States>(States.default);
  const [chargeBack, setChargeBack] = useState<ChargeBack>();
  const { formData, formErrors, onChangeFormInput, isFormValid, resetForm } = useForm({
    initialData: {
      transactionCode: '',
    },
    validators: {
      transactionCode: [validators.required],
    },
  });

  const handleOnExport = async (): Promise<void> => {
    const idDiv = 'ExportToPdf';
    const elemento = document.getElementById(idDiv);

    if (!elemento) {
      throw new Error(`Div com id "${idDiv}" não encontrada.`);
    }

    const canvas = await html2canvas(elemento, {
      scale: 2, // melhora a qualidade
      useCORS: true,
    });

    const imgData = canvas.toDataURL('image/png');

    // eslint-disable-next-line new-cap
    const pdf = new jsPDF('p', 'mm', 'a4');

    const larguraPDF = pdf.internal.pageSize.getWidth();
    const alturaPDF = (canvas.height * larguraPDF) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, larguraPDF, alturaPDF);
    const pdfBlob = pdf.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfUrl, '_blank');
  };
  const handleOnFilter = async (): Promise<void> => {
    if (isFormValid()) {
      try {
        setState(States.loading);
        const { data } = await api.get<ChargeBack>(
          `/event/report/${formData[FormInputName.transactionCode]}/chargeback`,
        );
        if (data) {
          setChargeBack(data);
          resetForm();
        }
      } catch (error) {
        const err = error as AxiosError;
        toast.error(err.message);
      } finally {
        setState(States.default);
      }
    }
  };
  return (
    <ChargebackContainer
      state={state}
      formData={formData}
      formErrors={formErrors}
      onChangeFormInput={onChangeFormInput}
      onFilter={handleOnFilter}
      chargeBack={chargeBack}
      onExport={handleOnExport}
    />
  );
};
